/** Central gameplay config. Split into more files later if needed. Keep design.md in sync when these change. */
export const GAME_CONFIG = {
  economy: {
    startingCash: 150,
    /** Treat reward = infection at spray start (see truck.progress snapshot) */
    fieldDeathPenalty: 50,
    winCash: 500,
  },

  units: {
    drone: {
      speed: 12,
      workProgressPerSec: 30,
      cruiseAltitude: 3,
      landAltitude: 0.35,
      verticalSpeed: 4,
    },
    truck: {
      speed: 7,
      /** Infection points removed per second while spraying (with fresh NDVI) */
      cleanRatePerSec: 15,
    },
    /** Seconds to wait at home after returning before becoming Idle */
    homeDwellSec: 1.5,
    workCompleteProgress: 100,
  },

  fields: {
    maxInfection: 100,
    infectionGrowthMin: 0.8,
    infectionGrowthMax: 2.8,
    reinfectionChance: 0.12,
    reinfectionAmount: 10,
    /** Full-opacity NDVI overlay duration after scan */
    ndviFreshSec: 12,
    /** Linear fade-out after fresh window */
    ndviFadeSec: 8,
  },

  /** Spray clean-rate multipliers relative to fresh NDVI (×1) */
  ndviSpray: {
    fresh: 1,
    fading: 0.5,
    none: 0.25,
  },

  autopilot: {
    speedMultiplier: 0.5,
    treatInfectionMin: 10,
  },

  reset: {
    infectionMin: 10,
    infectionSpan: 40,
  },
} as const;

export type GameConfig = typeof GAME_CONFIG;

/** Total NDVI lifetime (fresh + fade). */
export function ndviTotalSec(): number {
  return GAME_CONFIG.fields.ndviFreshSec + GAME_CONFIG.fields.ndviFadeSec;
}

/** Spray rate multiplier from remaining NDVI time. */
export function ndviSprayMultiplier(ndviRemaining: number): number {
  if (ndviRemaining <= 0) return GAME_CONFIG.ndviSpray.none;
  if (ndviRemaining <= GAME_CONFIG.fields.ndviFadeSec) return GAME_CONFIG.ndviSpray.fading;
  return GAME_CONFIG.ndviSpray.fresh;
}
